import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range.js";
import React from "react";
import { Dimensions, Platform } from "react-native";
import { FlatGrid } from "react-native-super-grid";

import { useIsMobileUX } from "@/components/hooks/useIsMobileUX";
import {
  hasDesktopStudio,
  openDesktopStudio,
} from "@/components/desktop/desktopApp";
import EventCard from "./EventCard";

const AppEventGrid = ({
  events = [],
  now = moment(),
  navigation,
  gridRef,
  onAddRoom,
  roomsAddable,
}) => {
  // const elements = sectionedEvents(events, now);
  const onEventSettingPressed = (event, params = {}) => {
    navigation.push("EventEdit", {
      slug: event.slug,
      event,
      key: event.slug,
      ...params,
    });
  };
  const onGoLivePressed = async (event, params = {}) => {
    // EventLive for Mac and Windows stream from their own Studio window, like
    // the phone apps; rooms still go through the event page to pick which one.
    if (
      hasDesktopStudio() &&
      !event.rooms?.length &&
      (event.is_published || event.is_test)
    ) {
      if (await openDesktopStudio(event)) return;
    }
    navigation.push("EventEdit", {
      slug: event.slug,
      event,
      key: event.slug,
      ...params,
    });
  };
  const isMobileUX = useIsMobileUX();

  const margin = 0;
  const itemDimension = isMobileUX ? Dimensions.get("window").width - 48 : 380;

  const isWeb = Platform.OS === "web";
  return (
    <FlatGrid
      ref={gridRef}
      showsVerticalScrollIndicator={true}
      showsHorizontalScrollIndicator={false}
      itemDimension={itemDimension}
      fixed
      data={events}
      spacing={10}
      itemContainerStyle={{ justifyContent: "flex-start" }}
      style={{
        marginTop: isWeb ? 20 : 0,
        paddingTop: isWeb ? 0 : 6,
        marginLeft: isWeb ? margin : null,
        marginRight: isWeb ? margin : null,
        marginBottom: 0,

        minHeight: "60%", // with the static container, there is an artifact when loading
        flex: 1,
      }}
      initialNumToRender={12}
      renderItem={(item) => (
        <EventCard
          onEventSettingPressed={onEventSettingPressed}
          onGoLivePressed={onGoLivePressed}
          onAddRoom={
            onAddRoom && item.item.rooms?.length && roomsAddable?.(item.item)
              ? onAddRoom
              : undefined
          }
          now={now}
          key={item.item.stream_key}
          event={item.item}
        />
      )}
    />
  );
};

export default AppEventGrid;
